<template>
<div>
            <div class="form-group">
                <label class="title6-5">First Name <span>*</span> </label>
                <input
                  v-validate="'required|min:2'"
                  id="FirstName"
                  v-model="editModel.FirstName"
                  name="firstName"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label class="title6-5">Last Name <span>*</span> </label>
                <input
                  v-validate="'required|min:2'"
                  id="LastName"
                  v-model="editModel.LastName"
                  name="lastName"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label class="title6-5">Email <span>*</span> </label>
                <input
                  v-validate="'required|email'"
                  id="EmailAddress"
                  v-model="editModel.Email"
                  name="email"
                  type="text"
                  class="form-control"
                />
              </div>
              <div class="form-group">
                <label class="title6-5">Phone <span>*</span> </label>
                <input
                  v-validate="{ required: true, min: 8, regex: this.getRegex(), max: this.getMax()}"
                  id="Phone Number"
                  v-model="editModel.Phone"
                  name="phoneNumber"
                  type="text"
                  class="form-control"
                />
              </div>
              <div ref="payment" >
                <div class="form-group">
                  <label class="title6-5 mt-2">Card Details </label>
                  <input
                    autocomplete="cc-number"
                    v-validate="'required|credit_card|CardNumberValidation'"
                    id="frmCCNum"
                    v-model="cardModel.CardNumber"
                    name="cardNumber"
                    type="text"
                    class="form-control"
                    placeholder="1234 1234 1234 1234"
                    maxlength="19"
                    v-mask="'#### #### #### ####'"
                  />
                  <div class="d-flex mt-3">
                    <input
                      autocomplete="cc-exp"
                      v-validate="{ required: true, CartValidation:12 }"
                      id="frmCCExp"
                      v-model.trim="cardModel.ExpireDate"
                      type="text"
                      name="expiryDate"
                      class="form-control"
                      placeholder="MM/YY"
                      v-mask="'##/##'"
                    />
                    <input
                      autocomplete="cc-csc"
                      v-validate="{ required: true, regex: /^[0-9]{3,4}$/ }"
                      id="frmCCCVC"
                      v-model="cardModel.CVV"
                      name="CVV"
                      type="text"
                      class="form-control"
                      placeholder="111"
                      v-mask="['###']"
                    />
                  </div>
                </div>

                <div class="form-group mt-2">
                  <label class="title6-5"
                    >Cardholder's Name <span>*</span>
                  </label>
                  <input
                    autocomplete="cc-name"
                    v-validate="'required|alpha_spaces'"
                    id="frmNameCC"
                    v-model="cardModel.CardHolder"
                    name="cardHolderName"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="form-check mt-2">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
                <label class="form-check-label title6-5" for="flexCheckDefault">
                  Save card for next time
                </label>
              </div>
</div>
</template>
<script>
import { mapGetters } from "vuex";
import { mask } from "vue-the-mask";

export default {
  name: "CheckoutComponent",
  directives: { mask },
  props: {
    editModel: {
      type: Object,
      default: () => {}
    },
    cardModel: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    ...mapGetters(["giftCartItems","giftDiscount","selectedCompany"]),
  },
  methods: {
    getMax(){
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? 10:15
    },
    getRegex(){
      let country = this.selectedCompany.Location.Country;
      return country == "AU" ? /04\d{8}/:/\d/
    },
    validate() {
      return this.$validator.validateAll();
    },
  }
}
</script>
